export default __webpack_public_path__ + "media/images/logo_transparent_white-2c6cf5e48945c4b38dcf8987f7919c20.svg";